export const hotelIndex: any = {
  noCreditCard: "クレジットカード不要",
  refundable: "キャンセル無料",
  viewMap: "地図を表示",
  extraFeeNotice: "現地のホテルで支払う税またはサービス料金があります",
};
